/**
 * Minimal type that can be used in the frontend and backend
 * Doing this so we don't have to depend on the server types here
 */
interface IGetIsFirstLabelArgs {
  shipment?: object | null;
  shipments?: ArrayLike<unknown> | null;
  dropoffs?: {
    chosen?: boolean | null;
    qrCodes?: readonly { shipmentGroupId?: string }[] | null;
  } | null;
}

export function shipmentGroupId(index: number): string {
  return `shipment/${index}`;
}

interface StoredShipmentIdentity {
  _id?: { toString(): string };
  _shipment?: { id?: string };
}

export function isSameReturnShipment(
  shipment: StoredShipmentIdentity | null | undefined,
  candidate: StoredShipmentIdentity | null | undefined,
): boolean {
  if (!shipment || !candidate) {
    return false;
  }
  const id = shipment._shipment?.id;
  return id
    ? candidate._shipment?.id === id
    : candidate === shipment ||
        (!!shipment._id &&
          candidate._id?.toString() === shipment._id.toString());
}

// A drop-off counts as a committed shipping method; replacedDropoffGroupId
// excludes the one a label is taking over so the swap stays first-label.
export function getIsFirstLabel(
  return_: IGetIsFirstLabelArgs,
  replacedDropoffGroupId?: string,
): boolean {
  const shipmentsLength = return_.shipments?.length ?? 0;
  const hasShipment = !!return_.shipment;
  const hasDropoff =
    replacedDropoffGroupId != null
      ? (return_.dropoffs?.qrCodes ?? []).some(
          (q) => q.shipmentGroupId !== replacedDropoffGroupId,
        )
      : !!return_.dropoffs?.chosen ||
        (return_.dropoffs?.qrCodes?.length ?? 0) > 0;
  const isFirstLabel = shipmentsLength === 0 && !hasShipment && !hasDropoff;
  return isFirstLabel;
}
